import { createReducer } from "redux-create-reducer";
import { CONTACT_ACTIONS } from "./contactActions";
import { MISC_CONTACT_ACTIONS } from "../misc/miscActions";
const INITIAL_STATE = {
    isLoading: false,
    error: null,
    isSuccess: null,
    fieldErrors: [],
    contactData: null,
    contactDataLoading: false,
    contactDataError: false
};
/**
 * Reducer creation and export.
 * Uses the constants above to define new state for each action
 */
export default createReducer(INITIAL_STATE, {
    [CONTACT_ACTIONS.CONTACT_STARTED](state, _action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: []
        };
    },
    [CONTACT_ACTIONS.DATA_LOAD_STARTED](state, _action) {
        return {
            ...state,
            contactDataLoading: true
        };
    },
    [CONTACT_ACTIONS.DATA_LOAD_SUCCEEDED](state, action) {
        return {
            ...state,
            contactData: action.payload,
            contactDataLoading: false,
            contactDataError: false
        };
    },
    [CONTACT_ACTIONS.DATA_LOAD_FAILED](state, _action) {
        return {
            ...state,
            contactDataLoading: false,
            contactDataError: true
        };
    },
    [CONTACT_ACTIONS.CONTACT_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [CONTACT_ACTIONS.CONTACT_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [CONTACT_ACTIONS.CONTACT_SUCCEEDED_TRUE](state, _action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true
        };
    },
    /* --- Reset Status Messages --- */
    [MISC_CONTACT_ACTIONS.RESET_MESSAGES](state, _action) {
        return {
            ...state,
            error: null,
            isSuccess: null,
            isLoading: false,
            fieldErrors: []
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/contact/contactReducer.ts